import React from "react";
import { Box, Divider, Link, Typography } from "@mui/material";
import { truncateText } from "../../helpers/Utils";

const MarkerDetailComponent: React.FC<{ newsData }> = ({ newsData }) => {
  return (
    <>
      {newsData.map((news, index) => (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "280px",
              gap: 2,
              marginTop: "10px"
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Link
                href={news.link}
                fontWeight="bold"
                color="inherit"
                variant="h6"
                underline="none"
                target="_blank"
                fontSize="14px"
              >
                {news.title
                  ? truncateText(news.title, 10)
                  : truncateText(news.content, 10)}
              </Link>
            </Box>
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                {news.time && (
                  <Typography
                    variant="caption"
                    sx={{
                      color: "gray",
                      marginRight: "10px",
                    }}
                  >
                    {news.time}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
          {index < newsData.length - 1 && <Divider style={{ background: '#ffffff', width: "100%" }}/>}
        </>
      ))}
    </>
  );
};

export default MarkerDetailComponent;
